// extracted by mini-css-extract-plugin
export default {"container":"CaseProceedStateButton_container__U8q6w"};